import React from 'react';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import DateUtils from 'js/lib/DateUtils';
import RequestStatus from 'new/elements/RequestStatus/RequestStatus';

export const getColumns = (onDetailClicked, selectedTab) => {
  if (selectedTab === 'incoming') {
    return [
      {
        name: 'Request ID',
        field: 'id',
        renderRow(row) {
          return (
            <ChipWithCopy tooltipTitle="Copy Request ID" toCopy={row.id}>
              {row.id}
            </ChipWithCopy>
          );
        },
        width: 12,
      },
      {
        name: 'Nexset',
        field: 'data_set.name',
        renderRow(row) {
          return (
            <a
              onClick={() =>
                onDetailClicked({
                  ...row.data_set,
                })
              }
            >
              {row.data_set.name}
            </a>
          );
        },
      },
      {
        name: 'Data Domain',
        field: 'domain.name',
      },
      {
        name: 'Requested by',
        field: 'requestor.full_name',
      },
      {
        name: 'Requested on',
        field: 'created_at',
        renderRow(row) {
          return DateUtils.getDateString(row.created_at);
        },
      },
      {
        name: 'Response',
        field: 'status',
        renderRow(row) {
          return (
            <RequestStatus
              status={row.status}
              selected_tab={'incoming'}
              request_type={row.request_type}
              datasetId={row.id}
            />
          );
        },
      },
    ];
  } else if (selectedTab === 'outgoing') {
    return [
      {
        name: 'Request ID',
        field: 'id',
        renderRow(row) {
          return (
            <ChipWithCopy tooltipTitle="Copy Request ID" toCopy={row.id}>
              {row.id}
            </ChipWithCopy>
          );
        },
        width: 12,
      },
      {
        name: 'Nexset',
        field: 'data_set.name',
        renderRow(row) {
          return (
            <a
              onClick={() =>
                onDetailClicked({
                  ...row.data_set,
                })
              }
            >
              {row.data_set.name}
            </a>
          );
        },
      },
      {
        name: 'Data Domain',
        field: 'domain.name',
      },
      {
        name: 'Requested on',
        field: 'created_at',
        renderRow(row) {
          return DateUtils.getDateString(row.created_at);
        },
      },
      {
        name: 'Response',
        field: 'status',
        renderRow(row) {
          return (
            <RequestStatus
              status={row.status}
              selected_tab={'outgoing'}
              request_type={row.request_type}
              datasetId={row.id}
            />
          );
        },
      },
    ];
  }
};
